import type { DeepSearchSource } from "./types";

export function getSourceEmoji(source: DeepSearchSource): string {
  switch (source.type) {
    case "academic":
      return "📄";
    case "video":
      return "🎥";
    default:
      return "📰";
  }
}
